import cx from 'classnames';
import { PropsWithChildren } from 'react';
import { Drawer } from 'vaul';

import { BoxStyleProps } from '../Box';
import styles from './BottomSheet.module.css';
import BottomSheetContext from './BottomSheetContext';

export interface BottomSheetProps extends BoxStyleProps {
  className?: string;
  contentClassName?: string;
  open?: boolean;
  onRequestClose?: () => void;
}

export default function BottomSheet({
  className,
  contentClassName,
  children,
  open,
  onRequestClose,
  ...otherProps
}: PropsWithChildren<BottomSheetProps>): JSX.Element | null {
  return (
    <Drawer.Root
      open={open}
      modal={true}
      onOpenChange={(open) => {
        if (!open) {
          onRequestClose?.();
        }
      }}
    >
      {open && <div className={cx(styles['overlay'], className)} />}
      <Drawer.Content className={cx(styles['modal-content'])} {...otherProps}>
        <div className={cx(styles['content'], contentClassName)}>
          <BottomSheetContext.Provider
            value={{ close: () => onRequestClose?.() }}
          >
            {children}
          </BottomSheetContext.Provider>
        </div>
      </Drawer.Content>
    </Drawer.Root>
  );
}
